<template>
  <div class="modal-login">
    <fn-modal
      full-screen-mobile
      class="modal-login"
      :loading="loading"
      max-width="m"
      keep-scroll-position
      @close="$emit('close')"
    >
      <fn-headline
        type="h2"
        icon="avatar"
      >
        {{ $t('forms.login.title') }}
      </fn-headline>

      <fn-vuex-form-login
        class="modal-login-form"
        :redirect-to="redirectEnabled ? $route.path : null"
        :redirect-enabled="redirectEnabled"
        :register-button="registerButton"
        @close="$emit('close')"
        @submit="$emit('close')"
      />
    </fn-modal>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    keepBodyScrollPosition: {
      type: Boolean,
      default: false,
    },
    registerButton: {
      type: Boolean,
      default: true,
    },
    redirectEnabled: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  data: () => ({
    loading: false,
  }),
});
</script>

<style lang="scss" scoped>
.modal-login {
  flex: 0 0 auto;

  :deep(.m-actions) {
    border-bottom: 0;
  }

  :deep(.m-content) {
    padding-top: 0;
  }

  :deep(.heading .icon) {
    color: $color-brand-fnmz-green;
  }
}
</style>
